import React from 'react';
import FlyingList from '@/apps/FlyingList';
import Layout from '../components/Layout';
import GlobalAuthorizationLayout from '../components/GlobalAuthorizationLayout';
import CheckStaffUserLayout from '../layout/CheckStaffUserLayout';

export const FlyListPage: React.FC = () => {
  return (
    <GlobalAuthorizationLayout>
      <CheckStaffUserLayout>
        <CheckStaffUserLayout>
          <Layout >
            <FlyingList />
          </Layout>
        </CheckStaffUserLayout>
      </CheckStaffUserLayout>
    </GlobalAuthorizationLayout>
  );
};

